import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { avanzoApi } from "@/lib/avanzoApi";

const KEY = "s1_route_2026_10";
const STEPS = [
  "Completa al menos 6 sesiones de entrenamiento de 13 preguntas y practica al menos 3 materias.",
  "Realiza tu Revisión de Progreso.",
  "Completa 4 sesiones adicionales de entrenamiento después de la revisión y asegúrate de haber practicado las 4 materias.",
  "¡Listo! Podrás realizar tu Simulacro 1.",
];

export const S1Announcement = ({ blocked }) => {
  const [pending, setPending] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    avanzoApi.announcementStatus(KEY)
      .then((r) => { if (!cancelled && !r.data?.seen) setPending(true); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  const close = (goTraining) => {
    setPending(false);
    avanzoApi.announcementSeen(KEY).catch(() => {});
    if (goTraining) navigate("/avanzo/entrenar");
  };

  return (
    <Dialog open={pending && !blocked} onOpenChange={(o) => { if (!o) close(false); }}>
      <DialogContent className="avz-announce" data-testid="avz-s1-announce">
        <span className="avz-announce-badge">QHUB.BUDDY · Buddy Avanza</span>
        <DialogTitle className="avz-announce-title" data-testid="avz-s1-announce-title">
          ¡Tu Simulacro 1 te espera!
        </DialogTitle>
        <DialogDescription asChild>
          <div className="avz-announce-body">
            <p>El Simulacro 1 ya está disponible en Buddy Avanza.</p>
            <p>Para desbloquearlo, primero debes completar tu entrenamiento y realizar la Revisión de Progreso.</p>
            <p className="avz-announce-sub">Sigue esta ruta:</p>
            <ol className="avz-announce-steps" data-testid="avz-s1-announce-steps">
              {STEPS.map((s, i) => (
                <li key={i}><span className="avz-announce-num">{i + 1}</span><span>{s}</span></li>
              ))}
            </ol>
          </div>
        </DialogDescription>
        <div className="avz-announce-actions">
          <button type="button" className="avz-btn avz-btn-secondary" onClick={() => close(false)}
                  data-testid="avz-s1-announce-ok">Entendido</button>
          <button type="button" className="avz-btn avz-btn-primary" onClick={() => close(true)}
                  data-testid="avz-s1-announce-train">Ir a mi entrenamiento</button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
